import { render, staticRenderFns } from "./UploadManualEmptyLegs.vue?vue&type=template&id=51c8b54c&"
import script from "./UploadManualEmptyLegs.vue?vue&type=script&lang=js&"
export * from "./UploadManualEmptyLegs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports